import Class from '@/Class';
import { IAsyncElementProvider, IAsyncTupleProvider } from '#/DefaultViewExtensionInterfaces';

export default class AsyncTypeGuards {
    public static isAsyncElementProvider(obj: any): obj is IAsyncElementProvider {
        const func = (obj as IAsyncElementProvider).getElementAsync;
        return func != undefined && typeof(func) === 'function';
    }

    public static isAsyncTupleProvider<T extends Class>(obj: any): obj is IAsyncTupleProvider<T> {
        const func = (obj as IAsyncTupleProvider<T>).getTupleAsync;
        return func != undefined && typeof(func) === 'function';
    }
}